<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.Hd" label="Hd"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.Td" label="Td"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.D" label="D"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 289 97.25"
         style="height: 150px"
    >
        <defs>
            <style>.hdtddhte1{fill:#eaf4fb;}.hdtddhte2{fill:#1d1d1b;}.hdtddhte3,.hdtddhte4,.hdtddhte5{fill:none;stroke:#0090c9;}.hdtddhte3{stroke-width:1.5px;}.hdtddhte4{stroke-width:3px;}.hdtddhte5{stroke-width:1.39px;}.hdtddhte6{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_HdTdDHTE_schema</title>
        <rect class="hdtddhte1"
              y="1.25"
              width="289"
              height="48" />
        <path class="hdtddhte2"
              d="M113.77,15.91h5.85c2.71,0,5.91,0,8.15,2.64a11.63,11.63,0,0,1,2.49,7.64c0,4.37-1.82,7.06-3.36,8.29-2,1.65-4.48,1.65-7.45,1.65h-5.68Zm2.8,17.92h2.74c1.93,0,4-.11,5.29-1.12,2.58-1.93,2.66-5.23,2.66-6.41,0-.75-.05-4.2-2-6.3-1.29-1.43-2.91-1.76-5.37-1.76h-3.36Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M216,36.13V18.29h-6.78V15.91h16.32v2.38h-6.77V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M258.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H271.8v2.46H258.89Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M63,36.13V18.29H56.17V15.91H72.5v2.38H65.72V36.13Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M85.15,15.94h2.63v18c0,.31.06,1.51.12,2.24H85.26l-.05-2.24A4.13,4.13,0,0,1,84,35.37a6.35,6.35,0,0,1-3.48,1c-1.87,0-6-1-6-7.14,0-5.35,3-7.67,6.35-7.67A4.53,4.53,0,0,1,85.15,24Zm-1,9a3.81,3.81,0,0,0-3.08-1.43c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.14,0,4.14-4.56,4.14-5.65A6,6,0,0,0,84.17,25Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M163.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M10.36,15.91v8.68H20V15.91h2.8V36.13H20V27H10.36v9.13H7.56V15.91Z"
              transform="translate(0 -0.75)" />
        <path class="hdtddhte2"
              d="M37.8,15.94h2.63v18c0,.31.06,1.51.12,2.24H37.91l0-2.24a4,4,0,0,1-1.26,1.48,6.34,6.34,0,0,1-3.47,1c-1.88,0-6.05-1-6.05-7.14,0-5.35,3.05-7.67,6.35-7.67A4.52,4.52,0,0,1,37.8,24Zm-1,9a3.8,3.8,0,0,0-3.08-1.43c-3.86,0-3.86,4.67-3.86,5.63,0,2.49.64,5.37,3.86,5.37,4.15,0,4.15-4.56,4.15-5.65A6,6,0,0,0,36.82,25Z"
              transform="translate(0 -0.75)" />
        <line class="hdtddhte3"
              x1="48.58"
              y1="1.25"
              x2="48.58"
              y2="97.25" />
        <line class="hdtddhte3"
              x1="96.75"
              y1="1.25"
              x2="96.75"
              y2="97.25" />
        <line class="hdtddhte3"
              x1="192.49"
              y1="1.25"
              x2="192.49"
              y2="97.25" />
        <line class="hdtddhte3"
              x1="240.66"
              y1="1.25"
              x2="240.66"
              y2="97.25" />
        <line class="hdtddhte4"
              x1="144.75"
              y1="1.25"
              x2="144.75"
              y2="97.25" />
        <line class="hdtddhte5"
              y1="49.75"
              x2="289"
              y2="49.75" />
        <line class="hdtddhte3"
              y1="0.75"
              x2="289"
              y2="0.75" />
        <text class="hdtddhte6"
              transform="translate(257.22 84.77)">{{rangeModel.E}}</text>
        <text class="hdtddhte6"
              transform="translate(112.22 84.77)">{{rangeModel.D}}</text>
        <text class="hdtddhte6"
              transform="translate(64.22 84.77)">{{rangeModel.Td}}</text>
        <text class="hdtddhte6"
              transform="translate(16.22 84.77)">{{rangeModel.Hd}}</text>
        <text class="hdtddhte6"
              transform="translate(208.22 84.77)">{{rangeModel.T}}</text>
        <text class="hdtddhte6"
              transform="translate(160.22 84.77)">{{rangeModel.H}}</text>
    </svg>
</ng-template>

